import { assertIsEntityDefined } from '../assertions';
import { getKeyBySelector } from '../keys';
/**
 * A map of entities that are indexed by a key.
 */
export class IndexedMap {
    constructor(entityName, entries, keySelector) {
        if (!keySelector) {
            this.map = new Map(entries);
        }
        else {
            this.map = new Map();
            for (const entity of entries) {
                const key = getKeyBySelector(entity, keySelector);
                this.map.set(key, entity);
            }
        }
        this.entityName = entityName;
    }
    /**
     * Returns a specified element from the Map object.
     * @returns the element associated with the specified key. Throws an error if no element is associated with the specified key.
     */
    get(key) {
        const element = this.map.get(key);
        assertIsEntityDefined(element, key, this.entityName);
        return element;
    }
    /**
     * Returns a specified element from the Map object if it has been set.
     * @returns the element associated with the specified key. If no element is associated with the specified key, undefined is returned.
     */
    getOptional(key) {
        return this.map.get(key);
    }
    /**
     * Adds a new element with a specified key and value to the Map. If an element with the same key already exists, the element will be updated.
     */
    set(key, value) {
        this.map.set(key, value);
        return this;
    }
    /**
     * @returns boolean indicating whether an element with the specified key exists or not.
     */
    has(key) {
        return this.map.has(key);
    }
}
//# sourceMappingURL=indexed-map.js.map